import styles from './Footer.module.scss';

export const Footer = () => {
  return (
    <footer className={styles.footer} data-testid="footer">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore necessitatibus in quas,
      similique, porro, earum sequi ullam quasi numquam molestias illum provident cum odit cumque
      illo nisi sapiente consectetur iure. Lorem ipsum dolor sit amet consectetur adipisicing elit.
      Rem deleniti culpa aperiam quasi? Repellat nemo, reiciendis rem ea dignissimos, enim sunt
      minima fugit delectus nulla pariatur debitis fuga odit magni! Lorem ipsum dolor, sit amet
      consectetur adipisicing elit. Nihil impedit repellat similique quis veniam.
    </footer>
  );
};
